import { CurrencyFormatFunc } from '../../../formatters/CurrencyFormat';

export default function ProductSpecificationsData(minAge, maxAge, minCoverageAmount, maxCoverageAmount, termLengths) {
	minCoverageAmount = CurrencyFormatFunc(minCoverageAmount, true);
	maxCoverageAmount = CurrencyFormatFunc(maxCoverageAmount, true);
	return ([
		{
			title: "Issue Ages",
			text: `${minAge} to ${maxAge} years`,
		},
		{
			title: "Coverage Amounts",
			text: `<span>${minCoverageAmount}-${maxCoverageAmount}</span>`,
		},
		{
			title: "Features",
			text: `<div>Long-term care benefit</div>
                <div>Death benefit</div>
				<div>Cash value</div>`,
		},
		{
			title: "Additional Benefits",
			text: `Inflation protection <div class="mt-2">*<small>features and benefits vary by carrier</small></div>`,
		},
	])
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/asset-based-ltc/ProductSpecificationsData.js